import applicationRepository from './en-US/applicationRepository';
import component from './en-US/component';
import deploymentOperations from './en-US/deploymentOperations';
import eventEngine from './en-US/eventEngine';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import projectSettings from './en-US/projectSettings';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import system from './en-US/system';
import workbench from './en-US/workbench';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.banner.title': 'Super Software Factory',
  'app.banner.subtitle': 'Intelligent Software Lifecycle Management System',
  'app.footer.copyright': '2026 Coral Wisdom (Beijing) Technology Lt., Co',
  'app.preview.down.block': 'Download this page to your local project',
  'app.workbench.link.fetch-blocks': 'Get all block',
  'app.workbench.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...applicationRepository,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...projectSettings,
  ...component,
  ...deploymentOperations,
  ...eventEngine,
  ...pages,
  ...workbench,
  ...system,
};
